import { Stack, Text, TileBar, VisuallyHidden } from '@eneco/sparky';
import { DocumentIcon, DownloadIcon, SpinnerIcon } from '@eneco/sparky/icons';
import { DC_Domain_Models_Contracts_ContractState, DC_Domain_Models_Products_ProductType } from '@monorepo-types/dc';

import { getContractName } from './utils';

interface DownloadContractTileProps {
  documentId: string;
  productTypes: DC_Domain_Models_Products_ProductType[] | null | undefined;
  isValidating: boolean;
  onDownloadContract: (documemtId: string) => void | Promise<void>;
  contractState: DC_Domain_Models_Contracts_ContractState;
}

export const DownloadContractTile = ({
  documentId,
  productTypes,
  isValidating,
  onDownloadContract,
  contractState,
}: DownloadContractTileProps) => {
  const contractLabel = getContractName(productTypes);

  return (
    <TileBar.Item
      type="button"
      key={documentId}
      onClick={async () => await onDownloadContract(documentId)}
      ariaLabel={`${contractLabel} - ${contractState}`}>
      <Stack direction="row" gap="4" alignY="center">
        <DocumentIcon />
        <Stack.Item grow>
          {isValidating ? (
            <>
              <SpinnerIcon size="small" />
              <VisuallyHidden>{contractLabel}</VisuallyHidden>
            </>
          ) : (
            <Text align="left" weight="bold" size="BodyS">
              {contractLabel}
            </Text>
          )}
        </Stack.Item>
        <DownloadIcon />
      </Stack>
    </TileBar.Item>
  );
};
